<div class="lv-artefact-container lv-component"
     [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <mat-icon *ngIf="!isImage" [ngClass]="[!!uiArtefakt?.SymbolGroesseInPixel ? uiArtefakt?.SymbolGroesseInPixel: '',
 !!uiArtefakt?.SymbolFarbe ? uiArtefakt?.SymbolFarbe: '']" class="lv-symbol"
            [svgIcon]="uiArtefakt?.Symbolbezeichnung"></mat-icon>
  <div *ngIf="isImage" class="lv-artefact lv-border" [ngClass]="uiArtefakt.BreiteInPixel">
    <img  class="lv-image" [src]="getHostname() + 'assets/images/' + getImageFilename()"
         [alt]="uiArtefakt.Symbolbezeichnung">
  </div>
</div>
